import React, { useState } from "react";
import { Link } from "gatsby";
import {
  languagesSet1,
  languagesSet2,
  languagesSet3,
  languagesSet4,
  languagesSet5,
  languagesPairsSet1,
  languagesPairsSet2,
  languagesPairsSet3,
  languagesPairsSet4,
  languagesPairsData,
  languagesDataMobile1,
  languagesDataMobile2,
  languagesPairsDataMobile1,
  languagesPairsDataMobile2,
} from "./config";

function MainLanguages() {
  const [openLanguages, setOpenLanguages] = useState(false);
  const [openLanguagesPairs, setOpenLanguagesPairs] = useState(false);
  const [languageAccordian, setLanguageAccordian] = useState(true);
  const [languagePairsAccordian, setLanguagePairsAccordian] = useState(true);

  const languageHandler = () => {
    setOpenLanguages((open) => !open);
    setLanguageAccordian((open) => !open);
  };
  const languagePairsHandler = () => {
    setOpenLanguagesPairs((open) => !open);
    setLanguagePairsAccordian((open) => !open);
  };

  const chevronUp = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="currentColor"
      class="bi bi-chevron-up"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
      />
    </svg>
  );

  const chevronDown = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="currentColor"
      class="bi bi-chevron-down"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
      />
    </svg>
  );

  return (
    <section>
      <div className="bg-darkBlue py-28">
        <div className="w-11/12 lg:w-10/12 mx-auto max-w-6xl">
          <h2 className="font-secondary font-semibold text-45 text-white text-center mb-9 hidden sm:block">
            Over
            <span className="text-orange"> 120 languages</span>
          </h2>
          <h2 className="font-secondary font-semibold text-45 text-white text-center mb-9 block sm:hidden">
            Over
            <br />
            <span className="text-orange"> 120 languages</span>
          </h2>
          <div className="hidden md:grid grid-cols-5 justify-items-center">
            <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
              {languagesSet1.map(({ text, link }, i) => {
                return (
                  <li key={i}>
                    <Link
                      to={link}
                      className="cursor-pointer hover:text-orange transition-colors"
                    >
                      {text}
                    </Link>
                  </li>
                );
              })}
            </ul>
            <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
              {languagesSet2.map(({ text, link }, i) => {
                return (
                  <li key={i}>
                    <Link
                      to={link}
                      className="cursor-pointer hover:text-orange transition-colors"
                    >
                      {text}
                    </Link>
                  </li>
                );
              })}
            </ul>
            <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
              {languagesSet3.map(({ text, link }, i) => {
                return (
                  <li key={i}>
                    <Link
                      to={link}
                      className="cursor-pointer hover:text-orange transition-colors"
                    >
                      {text}
                    </Link>
                  </li>
                );
              })}
            </ul>
            <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
              {languagesSet4.map(({ text, link }, i) => {
                return (
                  <li key={i}>
                    <Link
                      to={link}
                      className="cursor-pointer hover:text-orange transition-colors"
                    >
                      {text}
                    </Link>
                  </li>
                );
              })}
            </ul>
            <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
              {languagesSet5.map(({ text, link }, i) => {
                return (
                  <li key={i}>
                    <Link
                      to={link}
                      className="cursor-pointer hover:text-orange transition-colors"
                    >
                      {text}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="grid md:hidden text-lightGray text-[16px]   grid-cols-1 main-languages gap-2">
            <div className="grid grid-cols-2 gap-2">
              {/* {languagesDataMobile1.map(({ text, link }, index) => {
                return (
                  <li key={index}>
                    <Link to={link} className="cursor-pointer">
                      {text}
                    </Link>
                  </li>
                );
              })} */}
              <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
                {languagesSet1.map(({ text, link }, i) => {
                  return (
                    <li key={i}>
                      <Link
                        to={link}
                        className="cursor-pointer hover:text-orange transition-colors"
                      >
                        {text}
                      </Link>
                    </li>
                  );
                })}
              </ul>
              <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
                {languagesSet2.map(({ text, link }, i) => {
                  return (
                    <li key={i}>
                      <Link
                        to={link}
                        className="cursor-pointer hover:text-orange transition-colors"
                      >
                        {text}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="mt-7">
              {languageAccordian && (
                <div className="flex justify-between items-center bg-midBlue px-3 py-4 bottom-1 rounded-sm max-w-sm">
                  <p className="text-[22px] text-white">See More</p>
                  <p onClick={languageHandler} className="cursor-pointer">
                    {chevronDown}
                  </p>
                </div>
              )}
              {openLanguages && (
                <div className="grid grid-cols-2 gap-2">
                  {/* {languagesDataMobile2.map(({ text, link }, index) => {
                    return (
                      <li key={index}>
                        <Link to={link} className="cursor-pointer">
                          {text}
                        </Link>
                      </li>
                    );
                  })} */}
                  <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
                    {languagesSet3.map(({ text, link }, i) => {
                      return (
                        <li key={i}>
                          <Link
                            to={link}
                            className="cursor-pointer hover:text-orange transition-colors"
                          >
                            {text}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                  <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
                    {languagesSet4.map(({ text, link }, i) => {
                      return (
                        <li key={i}>
                          <Link
                            to={link}
                            className="cursor-pointer hover:text-orange transition-colors"
                          >
                            {text}
                          </Link>
                        </li>
                      );
                    })}
                    {languagesSet5.map(({ text, link }, i) => {
                      return (
                        <li key={i}>
                          <Link
                            to={link}
                            className="cursor-pointer hover:text-orange transition-colors"
                          >
                            {text}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                  {/* <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
                    {languagesSet5.map(({ text, link }, i) => {
                      return (
                        <li key={i}>
                          <Link to={link} className="cursor-pointer">
                            {text}
                          </Link>
                        </li>
                      );
                    })}
                  </ul> */}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="bg-midBlue py-28">
        <div className="w-11/12 lg:w-10/12 mx-auto max-w-6xl">
          <h2 className="font-secondary font-semibold text-45 text-white mb-9 hidden sm:block text-center">
            950+
            <span className="text-orange"> Language Pairs</span>
          </h2>
          <h2 className="font-secondary font-semibold text-45 text-white mb-9 sm:hidden">
            950+
            <br />
            <span className="text-orange"> Language Pairs</span>
          </h2>
          <p className="text-gray text-[16px] mb-12">
            With global language offerings of more than 950+ language pairs,
            Tomedes can extend your message across the globe to each of your
            audiences. It's now easier for you to convey your meaning through
            professional translation done by expert translators. Coupled with a
            wide range of industry expertise for your business, these are our
            popular language pairs:With global language offerings of more than
            950+ language pairs, Tomedes can extend your message across the
            globe to each of your audiences. It's now easier for you to convey
            your meaning through professional translation done by expert
            translators. Coupled with a wide range of industry expertise for
            your business, these are our popular language pairs:
          </p>
          <div className="hidden md:grid grid-cols-4 justify-items-center">
            <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
              {languagesPairsSet1.map(({ text, link }, index) => {
                return (
                  <li key={index}>
                    <Link
                      to={link}
                      className="cursor-pointer hover:text-orange transition-colors"
                    >
                      {text}
                    </Link>
                  </li>
                );
              })}
            </ul>
            <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
              {languagesPairsSet2.map(({ text, link }, index) => {
                return (
                  <li key={index}>
                    <Link
                      to={link}
                      className="cursor-pointer hover:text-orange transition-colors"
                    >
                      {text}
                    </Link>
                  </li>
                );
              })}
            </ul>
            <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
              {languagesPairsSet3.map(({ text, link }, index) => {
                return (
                  <li key={index}>
                    <Link
                      to={link}
                      className="cursor-pointer hover:text-orange transition-colors"
                    >
                      {text}
                    </Link>
                  </li>
                );
              })}
            </ul>
            <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
              {languagesPairsSet4.map(({ text, link }, index) => {
                return (
                  <li key={index}>
                    <Link
                      to={link}
                      className="cursor-pointer hover:text-orange transition-colors"
                    >
                      {text}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          {/* <ul className="ml-7 md:ml-0 text-lightGray text-[16px] hidden md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 main-languages gap-2">
            {languagesPairsData.map(({ text, link }, index) => {
              return (
                <li key={index}>
                  <Link to={link} className="cursor-pointer">
                    {text}
                  </Link>
                </li>
              );
            })}
          </ul> */}
          <ul className="grid md:hidden text-lightGray text-[16px]   grid-cols-1 main-languages">
            <div className="grid grid-cols-2 gap-2">
              {/* {languagesPairsDataMobile1.map(({ text, link }, index) => {
                return (
                  <li key={index}>
                    <Link to={link} className="cursor-pointer">
                      {text}
                    </Link>
                  </li>
                );
              })} */}
              <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
                {languagesPairsSet1.map(({ text, link }, index) => {
                  return (
                    <li key={index}>
                      <Link
                        to={link}
                        className="cursor-pointer hover:text-orange transition-colors"
                      >
                        {text}
                      </Link>
                    </li>
                  );
                })}
              </ul>
              <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
                {languagesPairsSet2.map(({ text, link }, index) => {
                  return (
                    <li key={index}>
                      <Link
                        to={link}
                        className="cursor-pointer hover:text-orange transition-colors"
                      >
                        {text}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="mt-7">
              {languagePairsAccordian && (
                <div className="flex justify-between items-center bg-[#00245A] px-3 py-4 bottom-1 rounded-sm max-w-sm">
                  <p className="text-[22px] text-white">See More</p>
                  <p onClick={languagePairsHandler} className="cursor-pointer">
                    {chevronDown}
                  </p>
                </div>
              )}
              {openLanguagesPairs && (
                <div className="grid grid-cols-2 gap-2">
                  {/* {languagesPairsDataMobile2.map(({ text, link }, index) => {
                    return (
                      <li key={index}>
                        <Link to={link} className="cursor-pointer">
                          {text}
                        </Link>
                      </li>
                    );
                  })} */}
                  <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
                    {languagesPairsSet3.map(({ text, link }, index) => {
                      return (
                        <li key={index}>
                          <Link
                            to={link}
                            className="cursor-pointer hover:text-orange transition-colors"
                          >
                            {text}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                  <ul className="main-languages flex flex-col gap-2 text-lightGray text-base">
                    {languagesPairsSet4.map(({ text, link }, index) => {
                      return (
                        <li key={index}>
                          <Link
                            to={link}
                            className="cursor-pointer hover:text-orange transition-colors"
                          >
                            {text}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default MainLanguages;
